// extracted by mini-css-extract-plugin
module.exports = {"container":"Section_container__LfJkV","actions":"Section_actions__1C0Oa","action":"Section_action__15VWV","header":"Section_header__i_SNO","icon":"Section_icon__12IVN"};